/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from "@utils/loadable";

export const QHomePage = lazyLoad(
  () => import("./index"),
  (module) => module.QHomePage
);
